import { useEffect } from "react";
import { useStudentFilterContext } from "../../components/features/NewStudentFilter/useStudentFilterContext";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import OperatorPrivilegesStateInterface from "../../interfaces/OperatorPrivilegesStateInterface";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsStays from "./SectionsSettingsStays";
import { useFetchSectionStays } from "./useFetchSectionStays";

interface Props extends OutletContextProps {
  section: SectionInterface;
  operatorPrivileges: OperatorPrivilegesStateInterface;
}

const SectionsSettingsStaysPage_ = (props: Props) => {
  const { section, operatorPrivileges } = props;
  const { currentFilter } = useStudentFilterContext();

  const {
    sectionStays,
    isPending,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    error,
  } = useFetchSectionStays({ sectionId: section.id, query: currentFilter });
  useQueryError(error);

  useEffect(() => {
    props.setActiveMenu("stays");
  }, []);

  useOnMainScrollAreaScroll(() => {
    if (!isPending && !isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [isPending, isFetchingNextPage, hasNextPage, fetchNextPage]);

  return (
    <SectionsSettingsStays
      section={section}
      sectionStays={sectionStays || []}
      isLoading={isPending || isFetchingNextPage}
      privileges={operatorPrivileges.data?.privileges || []}
    />
  );
};

const pageInfo = {
  title: "入退室履歴",
};

export const SectionsSettingsStaysPage = enhanceSectionsSettingsPage(
  SectionsSettingsStaysPage_,
  pageInfo,
  ["stay:index"],
);
